import React from 'react';
import { css, styled } from '../../../../common/common.styles';
import { Column } from '../../../../common/components/layout/general/layout';
import { baseColor, primaryColor, secondaryColor } from '../../../styles/general/theme';
import { DotsStyling, SlideDotStyling, TransparentNextArrow, TransparentPrevArrow } from '../general/common-controls';

const SlimChevronRightSvg = (props: any) => (
  <svg
    className={props.className}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.38868 0.873047L0.710281 1.55241L5.4098 6.24425L0.709959 10.9514L1.38932 11.6298L6.76724 6.24297L1.38868 0.873047Z"
      fill="white"
    />
  </svg>
);

const SlimmerChevronRightSvg = (props: any) => (
  <svg
    className={props.className}
    width="13"
    height="24"
    viewBox="0 0 13 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3154 0.0102539L0.000610352 11.9979L0.0019332 11.9993L0 12.0014L11.3054 24L12 23.2628L1.38848 12.0006L12.0106 0.746807L11.3154 0.0102539Z"
      fill="black"
    />
  </svg>
);

const SlimChevronLeftSvg = (props: any) => (
  <svg
    className={props.className}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.61132 11.127L6.28972 10.4476L1.5902 5.75575L6.29004 1.04855L5.61068 0.370154L0.232758 5.75703L5.61132 11.127Z"
      fill="white"
    />
  </svg>
);

const SlimmerChevronLeftSvg = (props: any) => (
  <svg
    className={props.className}
    width="13"
    height="25"
    viewBox="0 0 13 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.68464 24.4897L12.9994 12.5021L12.9981 12.5007L13 12.4986L1.6946 0.500007L1 1.23719L11.6115 12.4994L0.989435 23.7532L1.68464 24.4897Z"
      fill="black"
    />
  </svg>
);

const RectChevronLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect opacity="0.5" width="32" height="32" fill="#4CC9F9" />
    <path
      d="M18.6123 21.127L19.2907 20.4476L14.5912 15.7558L19.291 11.0486L18.6117 10.3702L13.2337 15.757L18.6123 21.127Z"
      fill="white"
    />
  </svg>
);

const RectChevronRightIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.5" x="32" y="32" width="32" height="32" transform="rotate(-180 32 32)" fill="#4CC9F9" />
    <path
      d="M13.3877 10.873L12.7093 11.5524L17.4088 16.2442L12.709 20.9514L13.3883 21.6298L18.7663 16.243L13.3877 10.873Z"
      fill="white"
    />
  </svg>
);

export const PeuSlimChevronLeftIcon = styled(SlimChevronLeftSvg)`
  padding-top: 10px;
`;

export const PeuSlimmerChevronLeftIcon = styled(SlimmerChevronLeftSvg)`
  padding-top: 15px;
  padding-right: 4px;
`;

export const PeuSlimChevronRightIcon = styled(SlimChevronRightSvg)`
  padding-top: 10px;
`;

export const PeuSlimmerChevronRightIcon = styled(SlimmerChevronRightSvg)`
  padding-top: 15px;
  padding-left: 4px;
`;

export const PeuRectChevronLeftIcon = styled(RectChevronLeftIcon)``;
export const PeuRectChevronRightIcon = styled(RectChevronRightIcon)``;

export const PeuArrowStyle = css`
  width: 32px;
  height: 32px;
  border: 1px solid ${secondaryColor(700)};
  box-sizing: border-box;
  font-size: 26px;
  color: ${primaryColor(500)};
  background-color: transparent;
  display: flex !important;
  justify-content: center;
`;

export const PeuArrowDarkMode = css`
  border: none;
  color: ${baseColor(900)};
  background-color: ${primaryColor(300)};

  &:hover {
    background-color: ${baseColor(100)};
  }
`;

export const PeuArrowPrimaryMode = css`
  border: none;
  color: ${baseColor(900)};
  background-color: ${primaryColor(300)};

  &:hover {
    background-color: ${primaryColor(500)};
  }
`;

export const PeuPrevArrow = styled(TransparentPrevArrow)`
  ${PeuArrowStyle};
  top: calc(50% - 1em);
`;

export const PeuNextArrow = styled(TransparentNextArrow)`
  ${PeuArrowStyle};
  background-color: transparent;
  top: calc(50% - 1em);
`;

export const PeuPrimaryPrevArrow = styled(PeuPrevArrow)`
  ${PeuArrowPrimaryMode};
`;

export const PeuPrimaryNextArrow = styled(PeuNextArrow)`
  ${PeuArrowPrimaryMode};
`;

export const PeuSecondaryPrevArrow = styled(PeuPrevArrow)`
  border: none;
`;

export const PeuSecondaryNextArrow = styled(PeuNextArrow)`
  border: none;
`;

export const PeuDarkPrevArrow = styled(PeuPrevArrow)`
  ${PeuArrowDarkMode};
  ${(p) => p.theme.direction === 'rtl' && 'transform: rotate(180deg)'};
`;

export const PeuDarkNextArrow = styled(PeuNextArrow)`
  ${PeuArrowDarkMode};
  ${(p) => p.theme.direction === 'rtl' && 'transform: rotate(180deg)'};
`;

export const PeuDotsStyling = css`
  ${DotsStyling};

  & .slick-dots {
    > li {
      margin: 0 5px;

      > div {
        margin-right: 5px;
      }
    }
  }
`;

export const SlideDot = styled.div`
  ${SlideDotStyling};
  width: 16px;
  height: 16px;
  background-color: ${baseColor(400)};
`;

const PrevArrowShadow = styled(Column)`
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  background-image: linear-gradient(to right, #f7f7f7 0%, rgba(247, 247, 247, 0) 100%);
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 90px;
`;

const ForwardArrowShadow = styled(PrevArrowShadow)`
  background-image: linear-gradient(to left, #f7f7f7 0%, rgba(247, 247, 247, 0) 100%);
  right: 0;
  left: auto;
  width: 133px;
`;

export const PeuArrowBack = (props: any) => {
  return (
    <PrevArrowShadow>
      <PeuSecondaryPrevArrow icon={props.icon} onClick={props.onClick} />
    </PrevArrowShadow>
  );
};

export const PeuArrowForward = (props: any) => {
  return (
    <ForwardArrowShadow>
      <PeuSecondaryNextArrow icon={props.icon} onClick={props.onClick} />
    </ForwardArrowShadow>
  );
};
